import smartParkService from "../axios";

export const PermissionsService = async (park, payloadObj) => {
    return await (await smartParkService.get('api/park/' + park.parkid + '/rolepermissionrolenames?q=' + park.query)).data;
}